/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SsoTokenIssueRequestModel } from '../../models/sso-token-issue-request-model';
import { SykedSsoRedirectResponseModel } from '../../models/syked-sso-redirect-response-model';

export interface SykedIntegrationIssueSsoTokenPost$Params {
      body?: SsoTokenIssueRequestModel
}

export function sykedIntegrationIssueSsoTokenPost(http: HttpClient, rootUrl: string, params?: SykedIntegrationIssueSsoTokenPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<SykedSsoRedirectResponseModel>> {
  const rb = new RequestBuilder(rootUrl, sykedIntegrationIssueSsoTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<SykedSsoRedirectResponseModel>;
    })
  );
}

sykedIntegrationIssueSsoTokenPost.PATH = '/SykedIntegration/IssueSsoToken';
